import React, { useEffect, useRef, useState } from 'react';
import './table.css';
import Actions from './actions';
import DisplayModal from '../../modals/displayModal/displayModal';
import ConfirmationModal from '../../modals/confirmationModal';
import ViewModal from '../../modals/viewModal';
import { useNavigate } from 'react-router-dom';


const TableHeaders = ({ headers, selection, onHeaderCheckboxChange, selectedRows, body, access }) => {
  const [filteredHeaders, setFilteredheaders] = useState([]);
  const handleHeaderCheckboxChange = () => {
    onHeaderCheckboxChange();
  };

  useEffect(() => {     
    if(access && !access.grantCreate && !access.grantUpdate) {
      headers.map((heading) => {
        if(heading.tableKey == 'action' && !heading.actions.includes('action_download_stroke')){
          setFilteredheaders(headers.filter(v=> v.title !== 'Action'))
        }
        else{          
          setFilteredheaders(headers)
        }
      })
    }
    else{
      setFilteredheaders(headers)
    }
  }, [headers])

  return (
    <se-table-group-header>
      {selection ? <>
        <se-table-item-header key='allCheck' width='32px'>
          <se-checkbox onClick={() => handleHeaderCheckboxChange()} selected={selectedRows.length == body.length}></se-checkbox>
        </se-table-item-header>
      </> : null}
      {filteredHeaders?.map((item, i) => {
        return (
          <div key={i}><se-table-item-header min-width={item.width}><h5>{item.title}</h5></se-table-item-header></div>
        );
      })}
    </se-table-group-header>
  );
};
   
const TableBody = ({ headers, body, noData, availableActions, onActionComplete, tableColumnClicked, selection, onCheckboxChange, selectedRows, page, access }) => {
 
  const handleActionClick = (action, rowData) => {
    onActionComplete(action, rowData)
  }

  const handleClick = (field, item) => {
    tableColumnClicked(field, item)
  }

  const handleCheckboxChange = (id) => {
    onCheckboxChange(id);
  };

  useEffect(() => { }, [availableActions, headers])

  return (
    <>
      {!noData ? body.map((item) => {
        return (
          <se-table-group key={item.id}>
            {selection ? <>
              <se-table-item key='allCheck' width='32px'>
                <se-checkbox onClick={() => handleCheckboxChange(item.id)} selected={selectedRows?.includes(item.id)}></se-checkbox>
              </se-table-item>
            </> : null}
            {headers.map((heading) => {
              const productHighlight = heading.highlight && heading.tableKey && item && item[heading.tableKey] !== 0 ? 'highlightChild' : '';
              return (
                <div key={heading.tableKey + item.id} id='tableBodySE' style={{ width: heading.width, display: 'flex'}} className={productHighlight} >
                    {
                      heading.tableKey == 'action' &&
                      <Actions slot="trigger" actionItems={heading.actions} availableActions={availableActions} onActionClick={handleActionClick} rowData={item} page={page} access={access}/>
                    }
                  <se-tooltip position="top">
                    { 
                      heading.tableKey?.includes('Date') &&
                        <se-table-item slot="trigger">{new Date(item[heading.tableKey]).toLocaleDateString()}</se-table-item> 
                    }
                    {
                      heading.tableKey == 'status' &&                       
                      <se-table-item slot="trigger" style={item[heading.tableKey] == 'Test' || item[heading.tableKey] == 'Inactive' ? { color: '#DC0A0A' } : { color: '#3DCD58' }}>
                        {item[heading.tableKey]}
                      </se-table-item>
                    }
                    {
                      heading.tableKey !== 'status' && !heading.tableKey?.includes('Date') && heading.tableKey !== 'action' &&
                      <se-table-item slot="trigger" onClick={() => item[heading.tableKey] !== 0 && handleClick(heading.tableKey, item)}>{item[heading.tableKey]}</se-table-item>
                    }
                    {item[heading.tableKey]}
                  </se-tooltip>
                </div>
              );
            })}
          </se-table-group>
        );
      }) : <se-table-group style={{ alignItems: 'center' }}>No records found</se-table-group>}
    </>
  );
};
const Table = ({ columns, body, modalData, uploadModalData, page, selection, selectedData, access, onSave, onDelete, onPublish, productStatus, onDownload }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalValue, setModalValue] = useState(null);
  const [actionSelected, setAction] = useState(null);
  const [maxTableHeight, setMaxTableHeight] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const fixedHeightRef = useRef(0);
  const navigate = useNavigate();

  const  calcTableHeight = () => {
    const windowHeight = window.innerHeight;
    const header = 250;
    const subNavComp = document.querySelector('.subNavigationContainer')?.clientHeight || 0;
    fixedHeightRef.current = subNavComp + header + 50;
    const availableHeight  = windowHeight - fixedHeightRef.current;
    setMaxTableHeight(availableHeight > 200 ? availableHeight : 0)

  }

  useEffect(() => {
    calcTableHeight();
    return () => {
      window.removeEventListener('resize', calcTableHeight);
    }
  }, [])

  useEffect(() => {
    if (modalValue !== null && actionSelected !== null) {
      setModalVisible(!modalVisible)
    }
  }, [modalValue, actionSelected])

  const handleModalValue = (action, data) => {
    if (action?.includes('matterProductId')) navigate(`/ProductInformation/${data.matterProductId}?vid=${data.vid}`);
    if (action?.includes('productId')) navigate(`/ProductInformation/${data.productId}`);
    if (action?.toLowerCase()?.includes('download')) onDownload(data)
    else {
      setAction(action)
      setModalValue(data)
    }
  }

  const toggleModal = () => {
    setModalVisible(!modalVisible);
    setModalValue(null)
    setAction(null)
  }

  const handleCheckboxClick = (id) => {
    if (selectedRows?.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  const handleAllCheckboxClick = () => {
    let allIds = [];
    const safeBody = Array.isArray(body) ? body : [];
    if (selectedRows?.length === safeBody.length) {
      setSelectedRows([]);
    } else {
      allIds = safeBody.map((item) => item.id);
    }
    setSelectedRows(allIds);
  };

  useEffect(() => {
    if (selectedRows && page?.includes('device')) selectedData(selectedRows)
  }, [selectedRows])

  return (
    <se-table className='tableBox' style={{ display: 'block', height: '100%', maxHeight: maxTableHeight, overflowY: 'auto' }}>
      <TableHeaders headers={columns} body={body} selection={selection} onHeaderCheckboxChange={handleAllCheckboxClick} selectedRows={selectedRows} access={access}/>
      <TableBody body={body} noData={body.length > 0 ? false : true} headers={columns} onActionComplete={handleModalValue} tableColumnClicked={handleModalValue} selection={selection} onCheckboxChange={handleCheckboxClick} selectedRows={selectedRows} page={page} access={access}/>
      {
        modalVisible && actionSelected?.includes('edit') && <DisplayModal key={modalData?.pid} toggleModal={toggleModal} data={modalData} source={actionSelected} editFormValue={modalValue} onSave={onSave} page={page} fullDisableForm={false} productStatus={productStatus}/>
      }
      {
        modalVisible && actionSelected?.includes('delete') && <ConfirmationModal key={modalData?.pid} toggleModal={toggleModal} rowData={modalValue} action={actionSelected} onDelete={onDelete} page={page} />
      }
      {
        modalVisible && actionSelected?.includes('other') && <DisplayModal key={modalData?.pid} toggleModal={toggleModal} data={uploadModalData} editFormValue={modalValue} source="upload" page={page} onPublish_Upload={onPublish} onSave={onSave}/>
      }
      {
        modalVisible && actionSelected?.includes('Count') && <ViewModal toggleModal={toggleModal} data={modalData} itemValue={modalValue} source={actionSelected} />
      }

    </se-table>

  );
};

export default Table;